module.exports = __webpack_public_path__ + "img/map.20f05271.jpg";